<mat-form-field appearance="fill">
  <mat-label>Select Timeframe</mat-label>
  <mat-select [(value)]="selectedTimeframe" (selectionChange)="setTimeframe($event.value)">
    <mat-option *ngFor="let time of timeframes; trackBy: trackById" [value]="time"> {{ time }} days </mat-option>
  </mat-select>
</mat-form-field>
